import React, { useEffect, useState } from "react";
import { Image, StyleSheet, Text, View, TouchableOpacity } from "react-native";
import { connect } from "react-redux";
import { logoutUser, setUserData } from "../../actions/user";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import Container from "../../components/Container";
import Content from "../../components/Content";
import CustomButton from "../../components/CustomButton";
import CustomIcon from "../../components/CustomIcon";
import Header from "../../components/Header";

function Profile({ navigation, logout, userData = {}, setUserData }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (userData.username === undefined) {
      fetchApi({
        path: "/users/me",
      }).then((res) => {
        if (!res.error) {
          setUserData(res);
        }
        setIsReady(true);
      });
    } else {
      setIsReady(true);
    }
  }, []);

  const btnItems = [
    {
      title: "My Orders",
      onPress: () => {
        navigation.navigate("orders", {
          screen: "ordersscreen",
        });
      },
    },
    {
      title: "My Cards",
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "profile",
          params: {
            screen: "develop",
          },
        });
      },
    },
    {
      title: "Payment History",
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "profile",
          params: {
            screen: "develop",
          },
        });
      },
    },
    {
      title: "My Reviews",
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "profile",
          params: {
            screen: "develop",
          },
        });
      },
    },
    {
      title: "My Addresses",
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "profile",
          params: {
            screen: "addresses",
          },
        });
      },
    },
    // { title: "Change Email or Password" },
  ];

  const Item = ({ title, onPress = () => {} }) => (
    <TouchableOpacity
      onPress={onPress}
      style={{ ...STYLES.shadow, margin: 5, padding: 10 }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Text>{title}</Text>
        <CustomIcon
          type="AntDesign"
          name="right"
          style={{ fontSize: STYLES.fontSizes.small }}
        />
      </View>
    </TouchableOpacity>
  );

  return (
    <Container secure>
      <Header
        backButton
        title="My Account"
        rightIcons={[]}
        navigation={navigation}
      />
      <Content loading={!isReady} scrollEnabled>
        <View style={styles.container}>
          <View>
            <View
              style={{
                flexDirection: "row",
                padding: 10,
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              {userData.image_url ? (
                <Image
                  source={{ uri: userData.image_url }}
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 40,
                    marginRight: 10,
                  }}
                />
              ) : (
                <View
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 40,
                    marginRight: 10,
                    backgroundColor: STYLES.colors.purpel,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: STYLES.fontSizes.xxlarge * 1.4,
                      color: "#ffffff",
                    }}
                  >
                    {userData.username && userData.username[0]}
                  </Text>
                </View>
              )}
              <View>
                <Text
                  style={[styles.value, { fontSize: STYLES.fontSizes.xlarge }]}
                >
                  {userData.username}
                </Text>
                <Text style={styles.value}>{userData.email}</Text>
                <Text style={styles.value}>{userData.phone}</Text>
              </View>
            </View>
            {btnItems.map((data, index) => (
              <Item key={index} {...data} index={index} />
            ))}
          </View>

          <CustomButton
            text="Log Out"
            leftIcon={{ type: "Feather", name: "log-out" }}
            iconStyle={{ color: "#ffffff" }}
            btnStyle={{
              backgroundColor: "#000000",
              width: "80%",
              alignSelf: "center",
              marginTop: 40,
            }}
            onPress={() => logout()}
            textStyle={{ color: "#ffffff" }}
          />
        </View>
      </Content>
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
  },
  btn: {
    fontSize: 10,
    marginHorizontal: 3,
    borderWidth: 1,
    borderRadius: 20,
  },
  txtContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    margin: 5,
  },
  value: {
    fontWeight: "bold",
  },
});

const mapStateToProps = (state) => ({
  userData: state.user.userData,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logoutUser()),
  setUserData: (data) => dispatch(setUserData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
